const MAX_LABELS = 2;

function extractLabel(ref) {
    const value = ref && ref.value;

    if (value === undefined || value === null || value === '') return null;

    if (Array.isArray(value)) {
        const labels = value.map((item) => (item && typeof item === 'object' ? item.label : item)).filter(Boolean);

        if (!labels.length) return null;
        if (labels.length > MAX_LABELS) {
            return labels.slice(0, MAX_LABELS).join(', ') + ' +' + (labels.length - MAX_LABELS);
        }

        return labels.join(', ');
    }

    if (typeof value === 'object') return value.label || null;

    if (Array.isArray(ref.options)) {
        const option = ref.options.find((item) => item.value === value);
        if (option) return option.label;
    }

    return String(value);
}

export function buildFilterChip(name, title, ref) {
    return { name, title, label: extractLabel(ref) };
}
